let isLoaded = false

declare global {
  interface Window {
    grecaptcha: {
      ready: (cb: () => void) => void
      execute: (siteKey: string, options: { action: string }) => Promise<string>
    }
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const siteKey = config.public.recaptchaSiteKey as string

  if (!siteKey) {
    return {
      provide: {
        executeRecaptcha: async (_action: string) => '',
      },
    }
  }

  const loadScript = (): Promise<void> => {
    if (isLoaded) return Promise.resolve()

    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
      script.async = true
      script.onload = () => {
        isLoaded = true
        resolve()
      }
      document.head.appendChild(script)
    })
  }

  const executeRecaptcha = async (action: string): Promise<string> => {
    await loadScript()
    return new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(siteKey, { action }).then(resolve)
      })
    })
  }

  return {
    provide: {
      executeRecaptcha,
    },
  }
})
